import TranslationProvider, { getTranslation } from './TranslationProvider';

export {
  getTranslation,
};

export default TranslationProvider;
